import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { AlignmentVM } from './AlignmentVM';
import { D3LinePlot } from 'cd-eft/components/common/D3LinePlot/D3LinePlot';
import { Table } from 'reactstrap';
import { SOSurveyActions } from '../SOSurveyActions';
import stores from 'cd-eft/models/Stores';
import { Accordion } from 'cd-eft/components/common/Accordion';

const setStore = stores.AppStore.surveyEngineeringStore;

interface IAlignmentComponentProps {
  mapView?: any;
}

const AlignmentComponent = (props: IAlignmentComponentProps) => {
  const vm = useRef(new AlignmentVM({ ...props })).current;
  const currentObject = setStore.stationOffsetObject;

  return (
    <div data-testid="alignment">
      <Accordion headers={['Profile']} expanded={true} >
        <div className="so-graph-container">
          <D3LinePlot targetDivID={vm.targetDivID} windowOptions={vm.windowOptions} plotData={vm.plotData} />
        </div>
      </Accordion>

      <form className="usa-form usa-form--large form-with-fieldset">
        <div className="usa-fieldset p-2 mt-4">

          <div className="form-row-fixed-height">
            <label className="grid-col-3 usa-label pr-3" htmlFor="alignmentName">
              Alignment Name
            </label>

            <input
              className="grid-col-6 usa-input"
              name="alignmentName"
              aria-label="alignmentName"
              data-testid="alignmentName"
              placeholder={currentObject.alignmentName}
              value={currentObject.alignmentName}
              type="text"
              disabled
            />
          </div>

          <div className="form-row-fixed-height">
            <label className="grid-col-3 usa-label" htmlFor="beginning-station">
              Beginning Station
            </label>
            <input
              className="grid-col-2 usa-input"
              name="beginning-station"
              aria-label="beginning-station"
              data-testid="beginning-station"
              type="number"
              placeholder="0"
              value={currentObject.alignmentStations[0].stationDistance}
              onChange={vm.setBeginningStation}
            />
          </div>

          <div className="form-row-fixed-height">
            <label className="grid-col-3 usa-label" htmlFor="beginningX">
              Beginning X
            </label>
            <input
              className="grid-col-2 usa-input"
              name="beginningX"
              aria-label="beginningX"
              data-testid="beginningX"
              type="number"
              min={0}
              value={currentObject.beginningX}
              onChange={vm.setBeginningX}
            />
            <label className="grid-col-3 usa-label flex-justify-end" htmlFor="beginnigY">
              Beginning Y
            </label>
            <input
              className="grid-col-2 usa-input"
              name="beginningY"
              aria-label="beginningY"
              data-testid="beginningY"
              type="number"
              min={0}
              value={currentObject.beginningY}
              onChange={vm.setBeginningY}
            />
          </div>
        </div>

        <Accordion headers={['Table']} expanded={true} >
          <div className="set-table-container height-auto">
            <Table className="set-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>X</th>
                  <th>Y</th>
                  <th>Z</th>
                  <th className="nobr">Curve Type</th>
                  <th className="nobr">Curve Value</th>
                  <th className="nobr">To PI Station</th>
                </tr>
              </thead>

              <tbody>
                {currentObject.alignmentStations &&
                  currentObject.alignmentStations.map((alignmentStation: any, i: number) => (
                    <tr key={'key-alignmentStation-' + i}>
                      <td width="10%">
                        <input
                          className="usa-input"
                          name="stationName"
                          aria-label={`stationName-${i}`}
                          data-testid={`stationName-${i}`}
                          type="number"
                          placeholder="0"
                          value={alignmentStation.stationName | alignmentStation.stationDistance}
                          disabled
                        />
                      </td>
                      <td width="15%">
                        <input
                          className="usa-input"
                          name="x"
                          aria-label={`x-${i}`}
                          data-testid={`x-${i}`}
                          type="text"
                          value={alignmentStation.x}
                          disabled
                        />
                      </td>
                      <td width="15%">
                        <input
                          className="usa-input"
                          name="y"
                          aria-label={`y-${i}`}
                          data-testid={`y-${i}`}
                          type="text"
                          value={alignmentStation.y}
                          disabled
                        />
                      </td>
                      <td width="12%">
                        <input
                          className="usa-input"
                          name="z"
                          aria-label={`z-${i}`}
                          data-testid={`z-${i}`}
                          type="text"
                          value={alignmentStation.z}
                          disabled
                        />
                      </td>
                      <td>
                        <select
                          className="usa-select m-0"
                          name="curveType"
                          data-i={i}
                          data-testid={`curveType-${i}`}
                          value={+alignmentStation.curveType}
                          onChange={vm.updateSingleAlignmentStation}
                          disabled={true}
                        >
                          <option value={0}>- Select -</option>
                          <option value={1}>NONE</option>
                          <option value={2}>RADIUS</option>
                        </select>
                      </td>
                      <td>
                        <input
                          className="usa-input"
                          name="curveValue"
                          data-testid={`curveValue-${i}`}
                          data-i={i}
                          type="number"
                          min={0}
                          onChange={vm.updateSingleAlignmentStation}
                          value={alignmentStation.curveValue}
                          disabled={true}
                        />
                      </td>
                      <td>
                        <input
                          className="usa-input"
                          name="stationDistance"
                          aria-label={`stationDistance-${i}`}
                          data-testid={`stationDistance-${i}`}
                          type="number"
                          placeholder="0"
                          value={alignmentStation.stationDistance}
                          disabled
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
        </Accordion>

        <SOSurveyActions />
      </form>
    </div>
  );
};

export const Alignment = observer(AlignmentComponent);
